import React, { useState } from 'react';
import splashLogo from '../images/bennetts-daily-murder-mysteries.png';
import './SplashSelector.css';

const SplashSelector = ({ onSelectGame }) => {
  const [selectedGameIndex, setSelectedGameIndex] = useState(0);
  
  const games = [
    {
      id: 'mystery',
      title: 'Daily Murder Mystery',
      description: 'Solve today\'s murder mystery case by analyzing clues and interrogating suspects.',
      buttonText: 'Solve Today\'s Mystery'
    },
    {
      id: 'clue-sort',
      title: 'Clue Connections',
      description: 'Test your detective skills by sorting clues between two different cases.',
      buttonText: 'Solve Today\'s Challenge'
    }
  ];
  
  // Get today's date in a nice format
  // const formatDate = () => {
  //   const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  //   return new Date().toLocaleDateString('en-US', options);
  // };
  
  const handlePrevGame = () => {
    setSelectedGameIndex(prev => (prev > 0 ? prev - 1 : games.length - 1));
  };
  
  const handleNextGame = () => {
    setSelectedGameIndex(prev => (prev < games.length - 1 ? prev + 1 : 0));
  };
  
  const handleStart = () => {
    onSelectGame(games[selectedGameIndex].id);
  };
  
  const selectedGame = games[selectedGameIndex];
  
  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img 
          src={splashLogo} 
          alt="Bennett's Daily Murder Mysteries" 
          className="splash-logo"
        />
        <h2 className="splash-date">Sunday, May 28, 2025</h2>
        
        <div className="game-selector-wrapper">
          <button 
            className="game-nav-button prev"
            onClick={handlePrevGame}
            aria-label="Previous game"
          >
            &lsaquo;
          </button>
          
          <div className="game-info">
            <h3 className="game-title">{selectedGame.title}</h3>
            <p className="game-description">{selectedGame.description}</p>
          </div>
          
          <button 
            className="game-nav-button next"
            onClick={handleNextGame}
            aria-label="Next game"
          >
            &rsaquo;
          </button>
        </div>
        
        <div className="buttons">
          <button onClick={handleStart} className="start-button">
            {selectedGame.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SplashSelector; 